import cn from '@/lib/cs';
import React from 'react';

const AddIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<g clipPath="url(#a)">
			<path
				fill="currentColor"
				d="M14.1 10.1c-.7 0-1-.6-.8-1.3l.2-3V4.2l-.1-.8-.1-2.1-.1-.5-1-.7a1 1 0 0 0-1.4.3l-.3.5c-.2.2-.2.5-.2 1v1l.2 1.7V7l-.1 1.4c0 .3-.3.6-.6.6l-4 .3-1.2.2c-1.5.3-2.7.4-4 1v.1a1 1 0 0 0-.6 1c0 .3.1.6.3.8.7.4 1.3.3 2.3.2a3934 3934 0 0 1 6-.4 2 2 0 0 1 1.4 1.2v1l-.2 2.5v2.5l-.1 1-.1 1.3a2 2 0 0 0 1 1.9l.7.4h.2a7 7 0 0 0 1.4-3.9v-2.9l.3-2.5.2-1.5c0-.4.3-.6.6-.6H18l.9-.1c1.4-.3 3.4 0 4.7-.6.4-.2.6-.6.5-1a1 1 0 0 0-.3-.6h-.1c-.4-.4-.7-.5-1-.5h-6.8l-1.7.3Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="currentColor" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
);

export default AddIcon;
